import styled from 'styled-components';
import { Button } from 'components/atoms';
export const LargeButton = styled(Button)`
  min-width: ${({ theme: { spacing } }) => spacing(196)};
`;
